/**
 * An async version of withStyles intended for conditional stylesheet loading.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

function withStylesAsync(loader) {
	return (BaseComponent) => {
		class StyledAsyncComponent extends Component {
			constructor() {
				super();
				this.state = {
					hasFetched: false,
				};
			}

			componentDidMount() {
				loader().then((styles) => {
					this.setState({ hasFetched: true });
					this.removeCss = this.context.insertCss.apply(undefined, [styles]);
				});
			}

			componentWillUnmount() {
				if (this.removeCss) {
					this.removeCss();
				}
			}

			render() {
				if (this.state.hasFetched) {
					return <BaseComponent {...this.props} />;
				} else {
					return null;
				}
			}
		}

		StyledAsyncComponent.displayName = `WithStylesAsync(${
			BaseComponent.displayName || BaseComponent.name || ''
		})`;

		StyledAsyncComponent.contextTypes = {
			insertCss: PropTypes.func.isRequired,
		};

		return StyledAsyncComponent;
	};
}

export default withStylesAsync;
